import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import NavBar from "./components/header/Navbar";
import Sidebar from "./components/sidebar/Sidebar";
import Error from "./components/errorComponent";
import "./App.css";
 
function App() {
  const location = useLocation();
  const [mainBgColor, setMainBgColor] = useState("#F7EEF2");
 
  // useEffect(() => {
  //   // const pathname = window.location.pathname;
  //   if (location.pathname === '/sales-insights') {
  //     setMainBgColor('#F7EEF2')
  //   }else {
  //     setMainBgColor('#fafafa')
  //   }
  //   // window.scrollTo(0, 0);
  //   // document.title = 'TWT';
  // }, []);

      useEffect(() => {
    const faviconUrl ="https://mir-s3-cdn-cf.behance.net/projects/404/9451cc237988767.Y3JvcCw0MTQzLDMyNDEsODEwLDA.png"
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = faviconUrl;
  }, []);

  if (location.pathname === "/") {
    return <Navigate to="/finished-goods-inventory" replace />;
  }
 
  return (
    <div role="main" style={{ minHeight: "100vh" }}>
      <div
        style={{
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
          height: "8vh",
          minHeight: "50px",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
          position: "relative",
        }}
      >
        <NavBar />
      </div>
 
      <div style={{ display: "flex", height: "92vh" }}>
        {/* <Sidebar mainBgColor={location.pathname === "/sales-insights" ? "#F7EEF2" : "#fafafa"} /> */}
        <Sidebar
          mainBgColor={
            location.pathname === "/sales-insights" ? "#F7EEF2" : "#F7EEF2"
          }
        />
        <div
          style={{
            width: "100%",
            background:
              location.pathname === "/sales-insights" ? "#F7EEF2" : "#F7EEF2",
            height: "100%",
            overflowY: "auto",
            paddingRight: "20px",
          }}
        >
          <Error>
            <Outlet />
          </Error>
        </div>
      </div>
    </div>
  );
}
 
export default App